import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject, Signal } from '@angular/core';
import { createStateResetHandler } from '@appState/helpers';
import { CustomerReportLineResponse, ReportedCustomersFilterParams } from '@models/products-and-orders/customer-reports';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { CustomerReportsService } from '../customer-reports/customer-reports.service';

type ReportedCustomersState = {
  reportedCustomers: CustomerReportLineResponse[];
  isLoading: boolean;
};

const initialState: ReportedCustomersState = {
  reportedCustomers: [],
  isLoading: false,
};

export const ReportedCustomersStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withDevtools('reported-customers-store'),

  withMethods((store, customerReportsService = inject(CustomerReportsService)) => {
    createStateResetHandler<ReportedCustomersState>('/reported-customers')(store, initialState);
    return {
      getLines: rxMethod<ReportedCustomersFilterParams>(
        pipe(
          tap(() => {
            patchState(store, { isLoading: true });
          }),
          switchMap(params =>
            customerReportsService.getLines({ reportPeriodFrom: params.reportPeriodFrom, reportPeriodTo: params.reportPeriodTo }).pipe(
              tap(response => {
                patchState(store, { reportedCustomers: response, isLoading: false });
              }),
              catchError(() => {
                patchState(store, { isLoading: false });
                return EMPTY;
              }),
            ),
          ),
        ),
      ),
    };
  }),
);

export interface ReportedCustomersStoreType {
  readonly reportedCustomers: Signal<CustomerReportLineResponse[]>;
  readonly isLoading: Signal<boolean>;

  readonly getLines: (params: ReportedCustomersFilterParams) => void;
}
